<template>
  <div class="parts-list-container">
    <h2 class="chatbot-name">{{chatbot.name}}</h2>
    <div class="parts-list" @click="nextIndex(1)">
      <h2 v-if="scenario.length">
        クリックすることで次のパーツを見ることができます。
      </h2>
      <article class="preview-contents" v-if="scenario.length > 0">
        <section class="parts-card-section">
          <div class="parts-card" v-if="index >= 0">
            <h2 class="status-name">{{getPartsName(scenario[index].status)}}</h2>
            <div class="detail">
              <img class="img-icon" :src="getPartsImage(scenario[index].status)"/>
            </div>
          </div>
        </section>
        <section class="scenario-section" @click.prevent>
          <div class="scenario" style="height: 242px;" v-if="index >= 0">
            <!-- メッセージ -->
            <MessageParts
            :message="scenario[index].mainmessage"
            :speaker="speaker"
            :color="color"
            v-if="scenario[index].status === 2"/>
            <!-- 選択肢 -->
            <SelectParts
            :message="scenario[index].mainmessage"
            :speaker="speaker"
            :color="color"
            :logIndex="logIndex"
            :lastIndex="null"
            :isBot="isBot"
            :isDemo="isDemo"
            @pushButton="null"
            v-if="scenario[index].status === 0"/>
            <!-- 応募 -->
            <CVParts
            :message="scenario[index].mainmessage"
            :speaker="speaker"
            :color="color"
            :skInfo="null"
            :isDemo="isDemo"
            :logIndex="logIndex"
            :lastIndex="1"
            :companyData="chatbot.group"
            :renkeiID="null"
            @subscribe="null"
            @initScenario="null"
            v-if="scenario[index].status === 1"/>
            <!-- 入力フォーム -->
            <InputParts
            :isInputAfter="false"
            :logIndex="logIndex"
            :lastIndex="1"
            :isBot="isBot"
            :message="scenario[index].mainmessage"
            :speaker="speaker"
            :color="color"
            :isDemo="isDemo"
            @inputSubmit="null"
            :parameter="scenario[index].parameter"
            v-if="scenario[index].status === 6"/>
            <!-- 画像表示 -->
            <ImageParts
            :message="scenario[index].mainmessage"
            :speaker="speaker"
            v-if="scenario[index].status === 5"/>
            <!-- アップロードパーツ -->
            <UploadParts
            :speaker="speaker"
            :color="color"
            @sendfile="null"
            :parameter="scenario[index].parameter"
            :isDemo="isDemo"
            :logIndex="logIndex"
            :lastIndex="1"
            :sendedFlg="false"
            v-if="scenario[index].status === 7"/>
            <!-- カレンダーパーツ -->
            <CalendarParts
            :message="scenario[index].mainmessage"
            :speaker="speaker"
            :color="color"
            :logIndex="logIndex"
            :lastIndex="1"
            :isBot="isBot"
            :isErrorRecommendSchedule="false"
            :isDemo="isDemo"
            :preserveSuggestedSchedulesList="[]"
            :displayPrevBtnFlg="false"
            @makeCalendar="null"
            @submit="null"
            @nextDay="null"
            @prevDay="null"
            v-if="scenario[index].status === 4"/>
            <!-- 履歴書 -->
            <ResumeParts
            class='resume-parts'
            :speaker="speaker"
            :color="color"
            :parameter="scenario[index].parameter"
            :isDemo="isDemo"
            @pdf="null"
            v-if="scenario[index].status === 8"/>
            <!-- チェックボックスパーツ -->
            <CheckBoxParts
            :message="scenario[index].mainmessage"
            :speaker="speaker"
            :color="color"
            :parameter="scenario[index].parameter"
            :logIndex="logIndex"
            :lastIndex="1"
            :isBot="isBot"
            :isDemo="isDemo"
            @checkboxSubmit="null"
            v-if="scenario[index].status === 13"/>
            <!-- 動画パーツ -->
            <MovieParts
            :message="scenario[index].mainmessage"
            :speaker="speaker"
            :color="color"
            :parameter="scenario[index].parameter"
            v-if="scenario[index].status === 14"/>
            <!-- プルダウン選択パーツ -->
            <PullDownParts
            :message="scenario[index].mainmessage"
            :speaker="speaker"
            :color="color"
            :parameter="scenario[index].parameter"
            :logIndex="logIndex"
            :lastIndex="1"
            :isBot="isBot"
            :isDemo="isDemo"
            @pulldownSubmit="null"
            v-if="scenario[index].status === 15"/>
            <!-- カルーセルパーツ -->
            <CarouselParts
            style="display:none;"
            :message="scenario[index].mainmessage"
            :speaker="speaker"
            :parameter="scenario[index].parameter"
            :isBot="isBot"
            @pushButton="null"
            :logIndex="logIndex"
            :lastIndex="1"
            :isDemo="isDemo"
            v-if="scenario[index].status === 17"/>
            <!-- ダウンロードパーツ -->
            <DownloadParts
            :message="scenario[index].mainmessage"
            :speaker="speaker"
            :color="color"
            :parameter="scenario[index].parameter"
            @afterDownload="null"
            :logIndex="logIndex"
            :lastIndex="1"
            :isBot="isBot"
            :isDemo="isDemo"
            v-if="scenario[index].status === 18"/>
            <!-- 検索パーツ -->
            <SearchParts
            :message="scenario[index].mainmessage"
            :speaker="speaker"
            :color="color"
            :parameter="scenario[index].parameter"
            :companyData="chatbot.group"
            :skInfo="null"
            @pushSelect="null"
            @subscribe="null"
            @setRenkeiID="null"
            :logIndex="logIndex"
            :lastIndex="1"
            :isBot="isBot"
            :isDemo="isDemo"
            :renkeiID="null"
            v-if="scenario[index].status === 20"/>
          </div>
        </section>
      </article>
      <template v-else-if="loading">
        <p>ローディング中...</p>
      </template>
      <template v-else>
        <p>パーツがありません。</p>
      </template>
    </div>
    <div style="margin-top: 8px;">
      <b-progress
        type="is-info"
        :value="getInfoPercentage(index)"
        show-value
        format="percent">
      </b-progress>
    </div>
  </div>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
// メッセージパーツ
import MessageParts  from '@/components/BalloonParts/MessageParts'
import SelectParts   from '@/components/BalloonParts/SelectParts'
import CVParts       from '@/components/BalloonParts/CVParts'
import InputParts    from '@/components/BalloonParts/InputParts'
import ImageParts    from '@/components/BalloonParts/ImageParts'
import UploadParts   from '@/components/BalloonParts/UploadParts'
import UploadedParts from '@/components/BalloonParts/UploadedParts'
import CalendarParts from '@/components/BalloonParts/CalendarParts'
import ResumeParts   from '@/components/BalloonParts/ResumeParts'
import CheckBoxParts from '@/components/BalloonParts/CheckBoxParts'
import MovieParts    from '@/components/BalloonParts/MovieParts'
import PullDownParts from '@/components/BalloonParts/PullDownParts'
import CarouselParts from '@/components/BalloonParts/CarouselParts'
import DownloadParts from '@/components/BalloonParts/DownloadParts'
import SearchParts   from '@/components/BalloonParts/SearchParts'
import alterReplace  from '@/functions/alterStrReplace'
import cardList      from '@/assets/json/master/scenario.json'
export default {
  props: {
    chatbot: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: false
    }
  },
  components: {
    MessageParts  ,
    SelectParts   ,
    CVParts       ,
    InputParts    ,
    ImageParts    ,
    UploadParts   ,
    UploadedParts ,
    CalendarParts ,
    ResumeParts   ,
    CheckBoxParts ,
    MovieParts    ,
    PullDownParts ,
    CarouselParts ,
    DownloadParts ,
    SearchParts   ,
    alterReplace  ,
  },
  data () {
    return {
      index: 0,
      speaker: 'other',
      color: {
        balloonMy: '#911',
        balloonOtr: '#911',
        shadowType: true,
      },
      logIndex: 1,
      isBot: true,
      isDemo: false,
      scenario: [],
      allScenario: [],
      cardList: cardList,
      loading: false
    }
  },
  created () {
    if (this.type === 'store') {
      this.allScenario = this.chatbot.scenario_list
    } else {
      this.loading = true
      this.$store.dispatch('chatbot/getScenarioList',
        { companyid: this.chatbot.group, scenarioName: this.chatbot.scenario_name })
        .then((d) => {
          this.loading = false
          setTimeout(() => {
            this.allScenario = this.$_.cloneDeep(d.data)
            this.orderScenarioStartToGoal(this.$_.cloneDeep(d.data))
          }, 200)
        })
        .catch((e) => {
          this.loading = false
        })
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel', false)
    },
    nextIndex (delta) {
      const len = this.scenario.length
      const changeNum = this.index + delta
      if (changeNum === len) {
        // 超えたら最初に
        this.index = -1 * this.index
        setTimeout(() => {
          this.index = 0
        }, 50)
      } else if (changeNum === -1) {
        // マイナスになったら最大へ
        this.index = -1 * this.index
        setTimeout(() => {
        this.index = len - 1
        }, 50)
      } else {
        this.index = -1 * this.index
        setTimeout(() => {
        this.index = changeNum
        }, 50)
      }
    },
    getPartsName (status) {
      const idx = this.$_.findIndex(this.cardList, ['statusIdx', status + 1])
      return this.cardList[idx].name
    },
    getPartsImage (status) {
      const idx = this.$_.findIndex(this.cardList, ['statusIdx', status + 1])
      return require('../../../assets/template/' + this.cardList[idx].img)
    },
    getInfoPercentage (index) {
      const len = this.scenario.length
      if (this.loading) {
        return undefined
      } else if (len === 0) {
        return 0
      } else {
        if (this.scenario.lenth === 0) {
          return 100
        } else {
          return Math.abs(Math.floor((index + 1) / len * 100))
        }
      }
    },
    orderScenarioStartToGoal (scenario) {
      const startScenario = this.getScenarioStart(scenario)[0]
      this.scenario.push(startScenario)
      this.getNextNode(startScenario)
    },
    getScenarioStart (scenario) {
      return scenario.filter(v => v.start_flg)
    },
    getNextNode (scenario) {
      if (scenario.select.length === 1) {
        const nextNode = scenario.select[0].next_node
        this.searchMatchBeforeNode(nextNode)
      } else if (scenario.select.length > 1) {
        const selectIdx = this.getRandomInt(scenario.select.length)
        const nextNode = scenario.select[selectIdx].next_node
        this.searchMatchBeforeNode(nextNode)
      } else {
        throw new Error('The argument does not have the key name "select".')
      }
    },
    getRandomInt (max) {
      return Math.floor(Math.random() * Math.floor(max));
    },
    searchMatchBeforeNode(nextNode) {
      for (const scenario of this.allScenario) {
        if (scenario.beforenode === nextNode) {
          // 以前通過したシナリオに接続しループさせててる場合無限ループするので、そこで止める
          if (this.isSecondLap(scenario)) return
          else this.scenario.push(scenario)
          // ゴールの場合は次のシナリオへいかない
          if (scenario.is_cv) return
          else this.getNextNode(scenario)
        }
      }
      return
    },
    isSecondLap (s) {
      return this.scenario.filter(v => v.pk === s.pk).length >= 1
    }
  }
}
</script>

<style lang="scss" scoped>
.parts-list-container {
  padding: 16px;
  .chatbot-name {
    margin: 16px;
    text-align: left;
    font-size: 24px;
    font-weight: 600;
    color: #C82E42;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.parts-list {
  width: 100%;
  height: 320px;
  padding: 16px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  border: solid thin #ccc;
  cursor: pointer;
  h2.all-name {
    width: 100%;
    text-align: left;
    margin: 8px;
    font-size: 24px;
    font-weight: 600;
  }
  .parts-card {
    z-index: 1;
    padding: 8px;
    text-align: center;
    vertical-align: middle;
    margin: 4px;
    border: solid thin #ccc;
    background: white;
    border-radius: 8px;
    animation: SlideIn 0.4s;
    h2.status-name {
      font-size: 14px;
      text-align: center;
      width: 100%;
      font-weight: 600;
    }
    .detail {
      margin-top: 8px;
    }
    .img-icon {
      width: 70%;
    }
  }
}
.scenario {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 0;
  width: 100%;
  height: 100%;
  animation: SlideIn 0.4s;
}
.resume-parts {
  transform: scale(0.5,0.5);
}
/deep/ .-video {
  height: 100% !important;
}
.preview-contents {
  width: 100%;
  display: flex;
  align-items: center;
}
.parts-card-section {
  width: 30%
}
.scenario-section {
  width: 70%;
  overflow: auto;
  padding: 8px;
}
@keyframes SlideIn {
  0% {
    opacity: 0;
    transform: translateX(-64px);
  }
  50% {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ChatBot/organisms/DetailPartsPreview.vue